/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceMailingSettingsUpdateRequest
 */
export interface InvoiceMailingSettingsUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceMailingSettingsUpdateRequest
     */
    sendInvoiceByEmailToClient: boolean;
}

/**
 * Check if a given object implements the InvoiceMailingSettingsUpdateRequest interface.
 */
export function instanceOfInvoiceMailingSettingsUpdateRequest(value: object): value is InvoiceMailingSettingsUpdateRequest {
    if (!('sendInvoiceByEmailToClient' in value) || value['sendInvoiceByEmailToClient'] === undefined) return false;
    return true;
}

export function InvoiceMailingSettingsUpdateRequestFromJSON(json: any): InvoiceMailingSettingsUpdateRequest {
    return InvoiceMailingSettingsUpdateRequestFromJSONTyped(json, false);
}

export function InvoiceMailingSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceMailingSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sendInvoiceByEmailToClient': json['sendInvoiceByEmailToClient'],
    };
}

export function InvoiceMailingSettingsUpdateRequestToJSON(value?: InvoiceMailingSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sendInvoiceByEmailToClient': value['sendInvoiceByEmailToClient'],
    };
}

